// extracted by mini-css-extract-plugin
export default {"card":"QA17UgWWCAFBjPol0wbb-style-card","info":"JNcaE70OARpqTAxCXkfX-style-info","h4":"eLE2vlNwCpq5M5RuVbv0-style-h4","h3":"BVkRoPsb_NdbnvcLLodo-style-h3"};